import { connect } from 'react-redux';
import IsiJadwal from '../../../views/Kurikulum/MataPelajaran/IsiJadwal.view.js';
import { getStudent } from '../../../states/thunks/student.thunk';
import {
  getClasses, getParamOptionsAcademics, getTeacherOptions,
  getMapelDivOptions, getParamOptions, getDayOptions, getClassesOptions, getPrmLevels, getPeriodsOptions
} from '../../../states/thunks/options.thunk';
import { getScheduleGeneral, editScheduleGeneral, saveScheduleGeneral } from '../../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetStudent: () => dispatch(getStudent()),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleSaveScheduleSubject: (payload, goback) => dispatch(saveScheduleGeneral(payload, goback)),
    handleEditScheduleSubject: (payload, goback) => dispatch(editScheduleGeneral(payload, goback)),
    handleGetScheduleSubject: payload => dispatch(getScheduleGeneral(payload)),
    getMapelDivOptions: payload => dispatch(getMapelDivOptions(payload)),
    getTeacherOptions: payload => dispatch(getTeacherOptions(payload)),
    getDayOptions: payload => dispatch(getDayOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(IsiJadwal);
